import {EventPageVo} from '../../common/shared/api/gateway/event/EventPageVo.interface';
import {GetEventInfoPayload} from '../generated/types';
import {createAutomaticEvent} from './AutomaticEvent';

export function createGetEventInfoPayload(
  data: EventPageVo & {result_code: number}
): GetEventInfoPayload {
  return {
    eventId: data.event_id,
    eventTitle: data.event_title,
    eventVersion: data.event_version,
    isNeedUpdate: data.is_need_update,
    contentInfoList: data.content_info_list?.map(createAutomaticEvent) || [],
    userUid: data.user_uid,
    stoken: data.stoken,
    head: data.head,
    body: data.body,
    agreed: data.agreed,
    appUserId: data.app_user_id,
    nickname: data.nickname,
    orgCode: data.org_code,
    resultCode: data.result_code,
  };
}
